<sdps-modal [id]="modalId" [sdpsTitle]="title" class="sdps-custom-modal review-security-modal" [size]="'flex--large'"
            aria-label="Review Security Type Modal">
  <div slot="modal-body" class="modal-body">
    @if (selectedValues && (selectedValues | keyvalue).length > 0) {
      <div class="security-selected-result">
        <div class="sdps-p-bottom_small">
          <strong id="reviewSecuritySubHeader">{{ subTitleOverrideAndRestriction() }}</strong>
        </div>
        <div class="security-section" *ngFor="let item of selectedValues | keyvalue">
          <div class="security-row review-security-restrict-icon ">
            @if(formData?.override !== 'Y') {
              <sdps-icon class="security-delete-icon" [attr.sdps-id]="item.key + '_restrictedIcon'" sdps-aria-label="Restricted" type="functional" name="delete" size="small" color="error"></sdps-icon>
              } @else {
              <div class="check-icon">&#10003;</div>
             }
            <div class="security-name">{{ item.key }}</div>
            <div class="security-levels">
              <div class="security-level-item" *ngFor="let first of item.value">
                <span *ngIf="emtrConstant.reviewSecurityType.levelLabels[first.data.level]">{{ emtrConstant.reviewSecurityType.levelLabels[first.data.level] }} {{ first.data.desc }} ({{ first.data.code }})
                  <span *ngIf="first.data.selected">({{ first.data.selected }})</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    } @else {
      <sdps-notification type="information" class="sdps-m-top_none">
        <p class="sdps-notification__text">{{ emtrConstant.reviewSecurityType.emptyState }}</p>
      </sdps-notification>
    }
  </div>

  <div slot="modal-footer" class="modal-footer">
    <button type="button" class="btn btn-close" (click)="closeModal()">{{ emtrConstant.reviewSecurityType.close }}</button>
  </div>
</sdps-modal>
